import { createAction } from 'redux-actions';
import { IAuth } from './api';
import { AUTH_LOGIN, SET_TOKEN } from './constants';

export const authLogin = createAction(
  AUTH_LOGIN,
  (auth: IAuth) => ({ auth }),
);

export const setToken = createAction(
  SET_TOKEN,
  (token: string | null) => ({ token }),
);
